import React from 'react';
import { Tooltip, IconButton, Typography } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

interface HelpTooltipProps {
  title: string;
  content?: React.ReactNode;
  size?: 'small' | 'medium';
}

const HelpTooltip: React.FC<HelpTooltipProps> = ({ title, content, size = 'small' }) => {
  return (
    <Tooltip
      title={
        content || (
          <Typography variant="body2" sx={{ p: 0.5 }}>
            {title}
          </Typography>
        )
      }
      arrow
      placement="top"
    >
      <IconButton size="small" sx={{ p: 0.5, ml: 0.5 }}>
        <HelpOutline fontSize={size} />
      </IconButton>
    </Tooltip>
  );
};

export default HelpTooltip;